import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { ConfirmEmail as ConfirmEmailForm } from "ui/auth/ConfirmEmail"

export const ConfirmEmail = () => (
  <AuthenticationLayout type="signup">
    <ConfirmEmailForm />
  </AuthenticationLayout>
)
